import { createContext, useContext } from "react";

export const Barboza = createContext();

export function useBarboza() {
  return useContext(Barboza);
}
